import { render, staticRenderFns } from "./GenderAndBirthDate.vue?vue&type=template&id=86f93836&scoped=true&"
import script from "./GenderAndBirthDate.vue?vue&type=script&lang=js&"
export * from "./GenderAndBirthDate.vue?vue&type=script&lang=js&"
import style0 from "./GenderAndBirthDate.vue?vue&type=style&index=0&id=86f93836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f93836",
  null
  
)

export default component.exports